// extracted by mini-css-extract-plugin
module.exports = {"row-menu-trigger":"style_row-menu-trigger__1PnKa","row-menu":"style_row-menu__aSfLn","row-menu-icon":"style_row-menu-icon__3FVDA","row-menu-delete":"style_row-menu-delete__DqtOM"};